import React from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import MyTableRow from '../../common/TableRow'
import MyTableCell from '../../common/CustomTableCell'
import IconButton from '@material-ui/core/IconButton'
import CancelIcon from '@material-ui/icons/Cancel'

const crudColors = require('../../../assets/files/env.json').theme.colors.crud
const headers = require('../../../assets/files/headers.json')
	.drivers_unbind_table

const useStyles = makeStyles({
	avatar: {
		backgroundColor: '#fff',
		color: '#007AC4'
	}
})

const StyledTableCell = withStyles(theme => ({
	head: {
		backgroundColor: theme.palette.common.black,
		color: theme.palette.common.white
	},
	body: {
		fontSize: 14
	}
}))(TableCell)

const StyledTableRow = withStyles(theme => ({
	root: {
		'&:nth-of-type(odd)': {
			backgroundColor: theme.palette.action.hover
		}
	}
}))(TableRow)

function SimpleDialog(props) {
	const classes = useStyles()

	let numbering = 0
	let prop = props
	return (
		<Dialog
			onClose={props.closeShowVehiclesModal}
			aria-labelledby="simple-dialog-title"
			open={true}
		>
			<DialogTitle id="simple-dialog-title">المركبات التي يعمل بها</DialogTitle>
			<TableContainer component={Paper}>
				<Table
					size="small"
					className={classes.table}
					aria-label="customized table"
				>
					<TableHead>
						<MyTableRow header={headers}></MyTableRow>
					</TableHead>
					<TableBody>
						{prop.data.driver.current_bounding.map(function(item, index) {
							
							numbering++
							return (
								<StyledTableRow key={index}>
									<MyTableCell
										key={'driver_a' + index}
										value={numbering}
									></MyTableCell>
									<MyTableCell
										key={'driver_b' + index}
										value={item.vehicle ? item.vehicle.plate_number : 'U/N'}
									></MyTableCell>
									<MyTableCell
										key={'driver_c' + index}
										value={item.center ? item.center.name : 'U/N'}
									></MyTableCell>
									<MyTableCell
										key={'driver_d' + index}
										value={item.shift ? item.shift.name : 'U/N'}
									></MyTableCell>
									<StyledTableCell key={'veh_e' + index} align="right">
										<IconButton
											onClick={() => prop.unbindDriverFromVehicle(prop.data)}
										>
											<CancelIcon style={{ color: crudColors.d }} />
										</IconButton>
									</StyledTableCell>
								</StyledTableRow>
							)
						})}
					</TableBody>
				</Table>
			</TableContainer>
		</Dialog>
	)
}

export default SimpleDialog
